import { useMutation } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Customer-scoped bulk header-only refresh from Famous.
 *
 * Like {@link useRefreshArInvoiceHeadersFromFamous}, but the caller passes
 * customer ids instead of invoice ids — the server resolves every open invoice
 * for those customers and refreshes them (chunked internally). Use this on the
 * page-open hot path when the set of invoices isn't known client-side (e.g. the
 * bulk statement dialog opened from a payment-reminder task, which drives the
 * "Send All" fan-out across customers rather than a viewed invoice list).
 *
 * Intentionally silent — no success toast, no automatic cache invalidation.
 * The caller sequences follow-up reads off `isPending`.
 */
export function useRefreshArInvoiceHeadersForCustomersFromFamous() {
  return useMutation(
    orpc.accountsReceivable.arInvoices.refreshHeadersForCustomersFromFamous.mutationOptions(),
  );
}
